module.exports = __webpack_public_path__ + "img/all_categories.6fb238b6.svg";